/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockStatementEditCtrl
 */
angular.module('mercury.modules.stock.statement')
.controller('StockStatementEditCtrl', ["dialog", "ngToast", "$uibModal", "$q", "reporttime", "$scope", "$state", "$stateParams", "StockItems", "StockPurchaseOrders", "StockSuppliers", "StockSupplierStatements", "title", "userinfo", "$window", function(dialog, ngToast, $uibModal, $q, reporttime, $scope, $state, $stateParams,
  StockItems, StockPurchaseOrders, StockSuppliers, StockSupplierStatements, title, userinfo, $window) {
  //Because orders get refreshed from the server in some instances, we need to hold the reconciled status seperatly
  $scope.reconciledStatus = {};

  reporttime.defaultType = 'week';

  $scope.report = $stateParams.report;

  /**
   *  Updates the orders model depending on the statement information
   */
  var updateOrders = function() {
    $scope.loadingPromise = StockPurchaseOrders.getStatementOrders($scope.statement);
    $scope.loadingPromise.then(function(orders) {
      angular.forEach(orders.before, function(order) {
        order.disabled = true;
      });

      angular.forEach(orders.after, function(order) {
        order.disabled = true;
      });

      angular.forEach(orders.statement, function(order) {
        if (order.reconciled && order.statementId != $scope.statement.id) {
          order.otherStatement = true;
        }
      });

      $scope.orders = orders.before.concat(orders.statement, orders.after);
    });
  };

  /**
   * Initial Setup
   */
  if (angular.isDefined($stateParams.statementId)) {
    $scope.loadingPromise = StockSupplierStatements.get($stateParams.statementId).$promise;
    $scope.loadingPromise.then(function(statement) {
      $scope.statement = statement;

      angular.forEach($scope.statement.purchaseOrders, function(order) {
        $scope.reconciledStatus[order.id] = true;
      });

      title.set('Statement Reconciliation for ' + $scope.statement.supplierName);

      updateOrders();
    }, function() {
      $state.go('Stock.ReportSupplier', {report: $scope.report});
    });
  } else {//New Statement
    $scope.loadingPromise = StockSuppliers.get($stateParams.supplierId).$promise;
    $scope.loadingPromise.then(function(supplier) {
      $scope.statement = {
        datestampStart: reporttime.start(),
        datestampEnd: reporttime.end(),
        supplierId: $stateParams.supplierId,
        supplierName: supplier.name,
        statementAmount: 0
      };

      title.set('Statement Reconciliation for ' + $scope.statement.supplierName);

      updateOrders();
    }, function() {
      $state.go('Stock.ReportSupplier', {report: $scope.report});
    });
  }

  $scope.statementDataChange = function() {
    updateOrders();
  };

  /**
   *  Returns the sum of all reconciled orders.
   */
  $scope.amountOnStatement = function() {
    var total = 0;
    angular.forEach($scope.orders, function(order) {
      if ($scope.reconciledStatus[order.id]) {
        total += parseFloat(order.total);
      }
    });
    return total;
  };

  /**
   *  Save the current supplier statement changes to the server.
   */
  $scope.saveStatement = function() {
    $scope.statementDetailsForm.$setSubmitted();
    if ($scope.statementDetailsForm.$invalid) {
      ngToast.dismiss();
      ngToast.danger('Please fix the errors on this statement.');
      return;
    }

    $scope.statement.purchaseOrders = [];
    angular.forEach($scope.orders, function(order) {
      if (!order.disabled && $scope.reconciledStatus[order.id]) {
        $scope.statement.purchaseOrders.push(order);
      }
    });

    StockSupplierStatements.save($scope.statement)
    .then(function() {
      $state.go('Stock.ReportSupplier', {report: $scope.report});
    });
  };

  $scope.print = function() {
    $window.print();
  };

  $scope.editPurchaseOrder = function(id) {
    $state.go('.PurchaseOrderEdit', {id: id}, {location: 'replace'});
  };

  $scope.addAdjusting = function() {
    $state.go('.PurchaseOrderAdjustment', {supplierId: $scope.statement.supplierId, date: $scope.statement.datestampEnd}, {location: 'replace'});
  };

  //When we navigate back to this state from the purchase order editor, refresh the orders shown on the editor view.
  $scope.$on('$stateChangeStart', function(e, toState) {
    if (toState.name == 'Stock.StatementEdit' || toState.name == 'Stock.StatementAdd') {
      title.set('Statement Reconciliation for ' + $scope.statement.supplierName);
      updateOrders();
    }
  });
}]);
